let mockImages = [
    {
        "id": "17913901598497085",
        "caption": "Ukens farge💫\nFrisør: Marianne\n\n#waves #lorealpro #loreal #haircolor #frisør #frisørnorge #øygardenkommune #nfvb_insta #shinebright #instagood #instahair #har1kjeden #behindethechair #bakstolen2022_repostmeg",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274775566_371880234472701_2774565762678062349_n.jpg?_nc_cat=111&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=AO0LvdjSTMMAX8VnbfL&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-QGcIz7_m-IM-t_L-bV-8TTKSasslwuyxMu0O4NvfUjw&oe=621E4585",
        "permalink": "https://www.instagram.com/p/CaWl0CZMj04/",
        "thumbnail_url": "",
        "timestamp": "2022-02-24T09:15:25",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18123629266269425",
        "caption": "Snart vår🌱\nFrisør: Anita\n\n#frisør #frisørnorge #frisørbergen #øygardenkommune #lorealpro #waves #hairdresser #blonde #foil #instahair #instagood #nfvb_insta #nfvb #cosmoprofbeauty #loreal #lorealpro #kerastase #metaldx #hår1kjeden",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274638433_642229113657185_7280415486452639624_n.jpg?_nc_cat=100&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=10ThGLifpPAAX-yl4iT&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT951iyC7stpRD-hZI17haJFoqrL6QIWmmwEH1kRPqGx7w&oe=621D5340",
        "permalink": "https://www.instagram.com/p/CaS73-Nsrfz/",
        "thumbnail_url": "",
        "timestamp": "2022-02-22T23:11:14",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17932791716004395",
        "caption": "Foliestriper av flinke lærlingen vår Marthe!\n\n#lærling #folie #lorealpro #øygardenkommune #frisør #frisørnorge #hairdresser #instagood #instahair #kerastase #shuuemura #highlights #nfvb #nfvb_insta #har1kjeden",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274502892_1570472203318729_5078790541056362407_n.jpg?_nc_cat=101&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=-b6ddWcwvfsAX9WDs4G&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-u-sl8pyjEktAp6GHHwB0ey8JA2CYp6Bm4unBLVMH4NA&oe=621DBDED",
        "permalink": "https://www.instagram.com/p/CaPERvJMfFf/",
        "thumbnail_url": "",
        "timestamp": "2022-02-21T11:07:42",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17897949218475419",
        "caption": "Nydelig blond🤍 \nFrisør: Malene\n\n#blonde #lorealpro #waves #frisør #frisørnorge #øygardenkommune #nfvb_insta #instahair #hairdresser #foils #har1kjeden #dialight",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274025841_1161105781374155_6581904084755467819_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=hO-CtB20Is4AX_t-3hG&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_p23wadnm2biaAp_TM-Ro80KuaCY77cfcn0t3M-x-UFA&oe=621D0AAA",
        "permalink": "https://www.instagram.com/p/CaEzYjwMlw2/",
        "thumbnail_url": "",
        "timestamp": "2022-02-17T11:27:41",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17859758408661720",
        "caption": "💫HURRA💫\nGratulerer med bestått svenneprøve🌟\nVi er så stolt av deg! Du kan bestille time på salongcosmo.no eller 56336300🌟\n@andersenmalenee \n\n#svennebrev #frisør #øygardenkommune #nfvb #frisørbergen #frisørnorge #blonde #foils #har1kjeden #bakstolen #behindethechair #nfvb_insta #instagood #hairdresser",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273979572_310415891110914_2142721263307753603_n.jpg?_nc_cat=105&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Vxg3Svm0Z-IAX_wNqxh&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8Un88GQb7PniVstp8ibgwu9_xlxtxiwojJlxLkkuiF6Q&oe=621CA384",
        "permalink": "https://www.instagram.com/p/CaCpL-wslGL/",
        "thumbnail_url": "",
        "timestamp": "2022-02-16T15:20:06",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17855896559704895",
        "caption": "Shine Bright 💫\nFrisør: Monica\n\n#dialight #shine #blonde #frisør #frisørnorge #frisørbergen #nfvb_insta #instagood #instahair #metaldx #har1kjeden #bakstolen2022_repostmeg #behindethechair #cosmoprofbeauty #øygardenkommune",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273980075_793848771574462_890471811668408373_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Au-dDrgoJrkAX9wwqO7&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-FoxHV0783mbdGafju7nUeqnTF3YDKOhcqUqsPPSQtfQ&oe=621CFA73",
        "permalink": "https://www.instagram.com/p/CaBvyMcM7Ll/",
        "thumbnail_url": "",
        "timestamp": "2022-02-16T06:58:30",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18214837513137862",
        "caption": "Kobber pop🧡\nSwipe for video ⇉\nFrisør: Anita\n\n#lorealpro #lorealnorgepro #kobber #waves #nfvb #nfvb_insta #frisør #frisørbergen #frisørnorge #øygarden #pop #haircolor #cosmoprofbeauty #bakstolen #behindethechair #instahair #instagood",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273775517_325905195987713_6680201119069732289_n.jpg?_nc_cat=106&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=hBgnKbN91WcAX8BHaxG&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-Rye_Ms4JdKcdRUQpJeoWt0_LpYwR2V_wqyfjikgY4Yw&oe=621E1BAB",
        "permalink": "https://www.instagram.com/p/CZ2akW0sNjp/",
        "thumbnail_url": "",
        "timestamp": "2022-02-11T21:21:28",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17945246131754682",
        "caption": "Make the front pop!\nFlinke lærlingen vår Sofie sin kunde🤍 \n\n#moneypiece #makeitpop #lorealpro #frisørlærling #frisørbergen #frisørnorge #øygardenkommune #blonde #longhair #instabeauty #nfvb #nfvb_insta #behindethechair #cosmoprofbeauty #har1kjeden #instagood #fixit",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273633106_234420905569709_3645080020018312319_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=U1PgvZhVizQAX8tQ0vW&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8w3IKrZ-9DvoJu8ZecdRO_z2EOBncoQqo0apxPGOIxww&oe=621DD267",
        "permalink": "https://www.instagram.com/p/CZz2WAOjs3G/",
        "thumbnail_url": "",
        "timestamp": "2022-02-10T21:26:27",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17995877473412299",
        "caption": "The Beauty That Is Ingrid \nPart three\nFrisør/styling: @cosmo_anita \nMakeup: @mloveshair \n📸: @fotograflinnnesse \n\n#foto #photo #blonde #smile #hairdresser #lorealpro #lorealnorgepro #nfvb #bakstolen2022_repostmeg #cosmoprofbeauty #behindthechair #frisørbergen #frisørnorge #øygardenkommune #instabeauty #instagood #har1kjeden #shuuemura #kerastase #metaldx\n@teamvest_pro @nfvb_insta @lorealnorgepro @har1kjeden",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273416528_516621546439422_7089431171403506638_n.jpg?_nc_cat=106&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=oeHPfdu9KdAAX-0mzIy&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT__Cv7Z5gdyDc7vTWPrHEVWgcWSnx4SNHYLjKXxpdhPlA&oe=621E774E",
        "permalink": "https://www.instagram.com/p/CZuIVJJsJb0/",
        "thumbnail_url": "",
        "timestamp": "2022-02-08T16:08:11",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17938388089881262",
        "caption": "Sunday lookback🤎\nFrisør: Anita \n\n#metaldx #brunette #waves #frisørnorge #frisørinorge #frisørbergen #øygardenkommune #instahair #instagood #lorealpro #lorealnorgepro #kerastase #shuuemura #haircolor #nfvb #har1kjeden",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273504398_912506729397486_8355100955993298767_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=FdDvdn2Ymk4AX9fO5zj&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-fPr2Wju1lgvbmw07x6k6J7pGqJ3BvEhm0nrmZx5wuaw&oe=621D4FFC",
        "permalink": "https://www.instagram.com/p/CZo1kYLMJkZ/",
        "thumbnail_url": "",
        "timestamp": "2022-02-06T14:48:02",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17959111093594888",
        "caption": "Helgefin🌟\nFrisør: Monica\n\n#lorealpro #cosmoprofbeauty #blonde #highlights #shuuemura #kerastase #yubiblonde #frisørbergen #frisørnorge #frisør #øygardenkommune #instabeauty #instagood #nfvb #behindethechair #bakstolen2022_repostmeg #lorealnorgepro #har1kjeden #k18results",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273237023_253638263465405_6140059746187930947_n.jpg?_nc_cat=106&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=7oLH2yV_vM4AX9q_2o8&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_RdHZmIZuqNYktlQvp-2kaVQDUM9Q6lrxSlL8vP889YQ&oe=621E4889",
        "permalink": "https://www.instagram.com/p/CZl5uf3s5pX/",
        "thumbnail_url": "",
        "timestamp": "2022-02-05T11:26:39",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18123564601270348",
        "caption": "𝚃𝚑𝚎 𝙱𝚎𝚊𝚞𝚝𝚢 𝚃𝚑𝚊𝚝 𝙸𝚜 𝙸𝚗𝚐𝚛𝚒𝚍\n𝙿𝚊𝚛𝚝 𝚃𝚠𝚘 \n𝙷år/𝚂𝚝𝚢𝚕𝚒𝚗𝚐: 𝙰𝚗𝚒𝚝𝚊\n𝙼𝚊𝚔𝚎𝚞𝚙: 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n📸: @fotograflinnnesse \n\n#makeup #blonde #fotoshooting #beauty #øygarden #frisør #frisørbergen #frisørnorge #bakstolen #nfvb #nfvb_insta #cosmoprofbeauty #loreal #shuuemura #yubiblonde #lorealnorgepro #har1kjeden #instamood #instagood\n@teamvest_pro @lorealnorgepro",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273013192_618627805881391_7297955299446979193_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=JUxNj86M_N4AX9dvmWI&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_xKmBnV9aZJ7F6krzzjQsFBChoPa_4F5nEkvDJD4PgAw&oe=621D5488",
        "permalink": "https://www.instagram.com/p/CZezOresv0c/",
        "thumbnail_url": "",
        "timestamp": "2022-02-02T17:15:11",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17917723580206094",
        "caption": "𝚅𝚒𝚗𝚝𝚎𝚛 𝚋𝚕𝚘𝚗𝚍☁️\n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#winter #vinter #blonde #waves #roots #lorealpro #lorealnorgepro #instagood #frisørnorge #øygardenkommune #frisørbergen #blondehair #nfvb_insta #har1kjeden #cosmoprofbeauty",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272915954_522271459038183_1230180525489140652_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=jTuWQZy0f9cAX_3LJ1J&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8lLSaXzNehibSVs5cdHtt-tPfm5Th7MBOj2nvCflTrsg&oe=621E1950",
        "permalink": "https://www.instagram.com/p/CZZC9V5sOdF/",
        "thumbnail_url": "",
        "timestamp": "2022-01-31T11:37:11",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18025850371340597",
        "caption": "💫 \n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#sunday #waves #foilayage #roots #lorealpro #lorealnorgepro #nfvb #nfvb_insta #øygardenkommune #frisør #frisørnorge #behindthechair #har1kjeden #instagood #kerastase #k18hair",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272899607_526377661896251_967786600748724157_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=gOFSabrmddMAX_LSdDO&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_zxsLwP-ebNUA59wsWMW9aG9PfRsfN1CU8YbOVt5m7Jg&oe=621E1172",
        "permalink": "https://www.instagram.com/p/CZXZKPJMlKH/",
        "thumbnail_url": "",
        "timestamp": "2022-01-30T20:12:42",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18004621264386450",
        "caption": "𝚃𝚑𝚎 𝚋𝚎𝚊𝚞𝚝𝚢 𝚝𝚑𝚊𝚝 𝚒𝚜 𝙸𝚗𝚐𝚛𝚒𝚍 \n𝙿𝚊𝚛𝚝 𝚘𝚗𝚎\n𝙷å𝚛/𝚜𝚝𝚢𝚕𝚒𝚗𝚐: 𝙰𝚗𝚒𝚝𝚊\n𝙼𝚊𝚔𝚎𝚞𝚙: 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n📸: @fotograflinnnesse \n\n#lorealpronorge #lorealpro #shuuemura #blonde #beauty #instagood #har1kjeden #bakstolen #behindthechair #oneshothairawards #cosmoprofbeauty #nfvb #nfvb_insta @teamvest_pro @nfvb_insta @lorealnorgepro @fixitno @har1kjeden",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272713133_653689162493256_7648427129171084605_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=7Dq9DMyXWjIAX-n7T20&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8pVY0QGGzpQI4AwuJ4Lt2qDky-HUgxngQIqjKpEDJtBg&oe=621CB5F4",
        "permalink": "https://www.instagram.com/p/CZO2FlqsgnL/",
        "thumbnail_url": "",
        "timestamp": "2022-01-27T12:32:19",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18035687962323871",
        "caption": "𝚃𝚑𝚎 𝚍𝚊𝚛𝚔 𝚛𝚘𝚘𝚝𝚜💫\n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#lorealpro #lorealnorgepro #rootshadow #blonde #frisør #waves #frisørnorge #øygardenkommune #har1kjeden #kerastase #nfvb #nfvb_insta",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272659507_4750065251697870_1244229125835858878_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=_mePfic-l7cAX8E2TA7&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-NywHmyPAToxWq7tKTcMsAUNnvgskxLPOjKhIi9GHIQA&oe=621CECAE",
        "permalink": "https://www.instagram.com/p/CZL1OAgMzJ0/",
        "thumbnail_url": "",
        "timestamp": "2022-01-26T08:27:00",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17921152961154079",
        "caption": "𝙺𝚘𝚋𝚋𝚎𝚛 𝚖𝚊𝚗𝚍𝚊𝚐🧡\n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#kobber #copperhair #lorealpro #lorealnorgepro #frisør #øygardenkommune #frisørnorge #behindthechair #haircolor #har1kjeden #bakstolen #bangs #nfvb #nfvb_insta",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272498956_477847603928642_2458980263236913288_n.jpg?_nc_cat=100&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Yxt36Uy7-CMAX8xej4H&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9vRXNojYwQ_tRDEvX3FdFuRuxoPf0-RUOet77asHrDHw&oe=621E1C2A",
        "permalink": "https://www.instagram.com/p/CZG-iL6Mn8f/",
        "thumbnail_url": "",
        "timestamp": "2022-01-24T11:12:12",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17908110074377977",
        "caption": "𝙱𝚛𝚞𝚗𝚎𝚝𝚝𝚎🤎\n𝙷å𝚛 𝚊𝚟 𝚂𝚘𝚏𝚒𝚎\n\n#lærling #frisør #brunette #metaldx #lorealpro #øygardenkommune #lorealnorgepro #har1kjeden #cosmoprofbeauty #behindthechair #nfvb #nfvb_insta #instagood",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272485047_515701446442540_5682692932890548218_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=EsjIjzEa144AX84ff5c&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_PX0jZQN-lEkzziRBkZ-VEgM3Zw7rYEyV8KzlCDyGvvA&oe=621D02F9",
        "permalink": "https://www.instagram.com/p/CZErF_ZsTsq/",
        "thumbnail_url": "",
        "timestamp": "2022-01-23T13:43:51",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17900523155359319",
        "caption": "𝙱𝚛𝚘𝚗𝚍𝚎💫\n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚊𝚗𝚗𝚎\n\n#bronde #loreal #waves #lorealpro #shuuemura #metaldx #frisør #frisørnorge #øygardenkommune #øygarden #frisør #cosmoprofbeauty #har1kjeden #behindthechair #haircolor #hairstyle #nfvb #nfvb_insta",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272232236_2769215676719770_7622569056069043476_n.jpg?_nc_cat=105&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=3cqU0L5unKAAX8m-23v&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9O8dnszxT50kp-v_GuENWf8e9uwiArAo_Sbt1MZY2lWw&oe=621D4267",
        "permalink": "https://www.instagram.com/p/CY_BsZwMi0I/",
        "thumbnail_url": "",
        "timestamp": "2022-01-21T09:05:53",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17912803238337225",
        "caption": "🤍\n𝙷å𝚛: 𝙰𝚗𝚒𝚝𝚊\n📷: @fotograflinnnesse \n\n#winterblonde #lorealpro #lorealnorgepro #bakstolen #behindethechair #cosmoprofbeauty #frisør #frisørnorge #blinde #øygardenfrisør #har1kjeden #shuuemura #yubiblonde #nfvb #nfvb_insta @nfvb_insta @fixitno \n@teamvest_pro @lorealnorgepro \n@har1kjeden @oneshothairawards #oneshothairawards",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272174760_643877016755709_6367452676195103602_n.jpg?_nc_cat=100&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=sKe0_U7_fmMAX-RW1Do&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9RA2qakhXGqNibmjY5zz6EHprGRPieIs7j4QTYhyuj7g&oe=621E6288",
        "permalink": "https://www.instagram.com/p/CY8_hxHM9YI/",
        "thumbnail_url": "",
        "timestamp": "2022-01-20T14:08:28",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17930488576962346",
        "caption": "🤎 \n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#frisør #frisørnorge #brunette #øygardenkommune #øygarden #behinderhechair #har1kjeden #haircolor #haircut #nfvb_insta",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272091679_3527884977437889_8524593628959893401_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=VtqeWA6vAcAAX-DbuTS&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_Y7LEOcEC1U9iW6VGG9WffvMFbyAasmqxu9Qn9-fjonw&oe=621D21CD",
        "permalink": "https://www.instagram.com/p/CY3VJGFMMUf/",
        "thumbnail_url": "",
        "timestamp": "2022-01-18T09:21:54",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17889122171584441",
        "caption": "𝚂𝚘𝚏𝚝 𝚋𝚕𝚘𝚗𝚍𝚎☁️ \n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#softblonde #waves #frisørnorge #frisør #øygarden #tryggsalong #har1kjeden #nfvb #nfvb_insta #behindthechair #øygardenkommune #hairdresser #k18 #marianila",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272043858_463723431827823_593743821327534476_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=k1jOKyf1GVkAX-frAXr&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-vAITKKrYJXRXr3eBtTB0FjWvHqwXODwuISqP0WXwv-A&oe=621D6C0B",
        "permalink": "https://www.instagram.com/p/CY1W5D5M3OL/",
        "thumbnail_url": "",
        "timestamp": "2022-01-17T14:58:42",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "18162486400174330",
        "caption": "𝙶𝚘𝚍 𝙷𝚎𝚕𝚐💫 \n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚊𝚗𝚗𝚎\n\n#lorealpro #lorealnorgepro #highlights #blonde #frisørnorge #øygarden #øygardenkommune #frisør #bakstolen #behindethechair #nordichair #har1kjeden #nfvb #nfvb_insta",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/271855349_611344796759594_6463193724089819187_n.jpg?_nc_cat=102&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=UoHSugksle8AX_bN88H&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9hPyI65f_XV9bohSHXOQ2fSsTWiMF0jEBJVtCNiKrfaQ&oe=621E05B5",
        "permalink": "https://www.instagram.com/p/CYv57fusjh_/",
        "thumbnail_url": "",
        "timestamp": "2022-01-15T12:09:26",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17968257181471289",
        "caption": "𝙹𝚊𝚗𝚞𝚊𝚛 𝚋𝚕𝚘𝚗𝚍☁️\n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚕𝚎𝚗𝚎\n\n#blonde #lorealpro #lorealnorgepro #kerastase #shuuemura #cosmoprofbeauty #behindethechair #har1kjeden #øygardenkommune #øygarden #frisør #frisørnorge @teamvest_pro @lorealnorgepro @fixitno @nfvb_insta",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/271671355_1013734642511768_6541469494941401459_n.jpg?_nc_cat=110&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=YUJMglM3fIoAX-GcCS7&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8yVX5Bp52wdSPFUEiUU9aAKhCxzEh67YaRnmOjndEzOg&oe=621CCA7A",
        "permalink": "https://www.instagram.com/p/CYqS30LsmiY/",
        "thumbnail_url": "",
        "timestamp": "2022-01-13T07:51:56",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17879033951536464",
        "caption": "𝚂𝚞𝚗𝚍𝚊𝚢 𝚆𝚊𝚟𝚎𝚜 ☁️ \n𝙷å𝚛 𝚊𝚟 𝙼𝚊𝚛𝚒𝚝𝚑𝚊\n\n#waves #lorealpronorge #haircolor #frisørnorge #frisør #øygarden #øygardenkommune #kerastase #ågotnes #softcurls #caramel #beautiful #cosmoprofbeauty",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/271448044_486808369543599_9068243833781495430_n.jpg?_nc_cat=110&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=G5m9GWJ5fhIAX-cBUlr&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_f7xC_YoIy_i600IsMooy5z_y2XivuQXuGPXd448qIHw&oe=621CB57F",
        "permalink": "https://www.instagram.com/p/CYgdby8suMm/",
        "thumbnail_url": "",
        "timestamp": "2022-01-09T12:11:50",
        "username": "salongcosmo",
        "siteId": 305,
        "siteName": "Salong Cosmo avd Ågotnes Torg"
    },
    {
        "id": "17939904421802363",
        "caption": "Chocolate Brown🤎\n\nAv @hair.by.lokenhagen \n\n#askforwella #illuminacolor",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274547430_662820488248934_5190391437166040197_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=XpIW6nqVfLMAX9Ry2Sf&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9s5OGAYsGROj6uaY7nYeS17QPx_vlh2OzyXV0tMrRCxA&oe=621E186A",
        "permalink": "https://www.instagram.com/p/CaXxu2QqX8V/",
        "thumbnail_url": "",
        "timestamp": "2022-02-24T20:18:49",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17891811365594924",
        "caption": "Klipp og foliestriper av Hoa 🌻",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274635197_1295237904297512_4040458810853028815_n.jpg?_nc_cat=105&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=NZ-4B_duk1oAX_uqJ6U&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9ogqIF_LA5aDVbfIDCvYQfezYR0wTW3-ztCI5l2hNO-g&oe=621D002E",
        "permalink": "https://www.instagram.com/p/CaXaVWRquxB/",
        "thumbnail_url": "",
        "timestamp": "2022-02-24T16:54:21",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17930909723054762",
        "caption": "Striper og en god klipp 🤩\n\nAv @juliereginehair\n\n#askforwella",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274611083_920508871980367_1251887339325230949_n.webp?stp=dst-jpg&_nc_cat=101&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=gBAEx9Iy5YoAX_aJYQD&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-gOXTX4SFFqSB3q73SysiItIKyacgYhUkVBQw4iJktfQ&oe=621D6277",
        "permalink": "https://www.instagram.com/p/CaSswSUKeua/",
        "thumbnail_url": "",
        "timestamp": "2022-02-22T20:59:07",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17957955433615181",
        "caption": "✨ 𝙛𝙤𝙞𝙡𝙖𝙮𝙖𝙜𝙚 𝙤𝙣 𝙩𝙝𝙞𝙨 𝙙𝙧𝙚𝙖𝙢 𝙝𝙖𝙞𝙧 ✨\n\n- @hairbytherese_andersen \n\n#askforwella #wellanordic #foilayage",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274372971_5091871964227078_3776935697250280649_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=nO9mDbVIfSUAX_XDeCj&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_wtwIpRlFVGJAo3BpI1Y5JQIeUNr1WC7Si-6fqzjjCnw&oe=621D401E",
        "permalink": "https://www.instagram.com/p/CaP-QW_KlEE/",
        "thumbnail_url": "",
        "timestamp": "2022-02-21T19:34:19",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17951443225676230",
        "caption": "@juliereginehair var på wella sitt shimmering wonderland event i går 🤩 3 retters, masse ny inspirasjon og show!",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274235271_1605902966412975_2714164264331477120_n.webp?stp=dst-jpg&_nc_cat=102&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=1pSxlDrZN8EAX8g3GR8&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8yOWyAnO8JCvDBhUegvjZ73PQ2q8g1IvBhjRVdZdd0WQ&oe=621D2890",
        "permalink": "https://www.instagram.com/p/CaMYZb-q5or/",
        "thumbnail_url": "",
        "timestamp": "2022-02-20T10:05:47",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "18041694961316255",
        "caption": "Champagne blonde🥂\n\nBalayage med #freelightswella 9% og 12%\nGlosset med #colortouchwella 8/3, 9/36 og 9/97 med dobbel 1,9%\n\nGjort av @hairbytherese_andersen \n\nPS; jeg er en del ledige timer fremover, bestill i FixIt eller send meg en dm🖤\n\n#askforwella #k18",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/274062924_3055376758061854_338138486553577053_n.jpg?_nc_cat=102&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=SJqEkx4Zh3wAX_bYE-2&_nc_oc=AQnX6A_vH2OF9h5Fy7T4ShMbwiajRtDAipdhLLz3nHZ6iODwfwqUzW9mHvFX95xFIgk&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_yVO5qH04qyn0dqSAgcalVNq5z_QI80en_MX8lqKKXbA&oe=621DCDAB",
        "permalink": "https://www.instagram.com/p/CaEj-slKdBL/",
        "thumbnail_url": "",
        "timestamp": "2022-02-17T09:13:04",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17879671814627438",
        "caption": "God morsdag 💖",
        "media_type": 0,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273804442_684324365914107_3138264551075901338_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=ctgFWrIT_j4AX95fVuD&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_Y3igdNSnAh71xf7at8N7GTwQQ1AmzxHjyLXNKMwgvsA&oe=621E21A4",
        "permalink": "https://www.instagram.com/p/CZ6iNtgsdyY/",
        "thumbnail_url": "",
        "timestamp": "2022-02-13T11:45:15",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17928057605100624",
        "caption": "Dreamy 😍\n\nBabylights og glossing av @juliereginehair 🤍\n\n#wellahair",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273817541_466963701806010_6806335326080223937_n.webp?stp=dst-jpg&_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=JsPSCmm-1UEAX9ZZfh7&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT98MMbInd6YFTLq4aZU0UWjI6G_IGow29mglovE17Ijnw&oe=621D39AF",
        "permalink": "https://www.instagram.com/p/CZ4il1oKCfO/",
        "thumbnail_url": "",
        "timestamp": "2022-02-12T17:10:03",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17969784526521015",
        "caption": "Solkysset resultat ved naturlig balayage 🌸😍\n@stylingbypiahl \n.\n.\n.\n.\n#askforwella #wellanordic #freelightswella #olaplex #olaplexnorge #ghd #ghdhair #oribeobsessed #oribehair",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273851803_244486731213791_3495781325193359150_n.jpg?_nc_cat=100&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=RFgZTUIabXkAX9CeD3K&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8nZqtzCUAaM6RIFUKHmumsJK0e3KP2pTJ5q5ccrotPHQ&oe=621E1471",
        "permalink": "https://www.instagram.com/p/CZ4K98IqxfW/",
        "thumbnail_url": "",
        "timestamp": "2022-02-12T13:43:38",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17908137362411955",
        "caption": "𝙿𝚊𝚗𝚎𝚕𝚎𝚛 🤍\n\nAv @juliereginehair\n\n#askforwella",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273803595_3037621049813316_1150229940622602531_n.webp?stp=dst-jpg&_nc_cat=103&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=0sF38PurWMEAX9fXjgL&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_VXpvWzRT9IDElgyI1TOEBbpIeD3YFXO15G1b4e1gjzw&oe=621DE8C4",
        "permalink": "https://www.instagram.com/p/CZz1F3mquFi/",
        "thumbnail_url": "",
        "timestamp": "2022-02-10T21:15:31",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "18225679264100929",
        "caption": "Striper hele lengder for spill 😊✨\n@stylingbypiahl \n.\n.\n.\n.\n#askforwella #wellanordic #blondorwella #olaplex #olaplexnorge #oribeobsessed #oribe #ghd #ghdhair #marianila #marianilastockholm",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273550517_641649570499765_10147020550808060_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=F2-QuIc8e-0AX_m74pI&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_hEB81Mwye5bNoqKt1yvlsYNFQ-Ad0dNBp0elkr2y5cw&oe=621DB640",
        "permalink": "https://www.instagram.com/p/CZw-SRNqEhV/",
        "thumbnail_url": "",
        "timestamp": "2022-02-09T18:38:08",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17928730082071975",
        "caption": "“𝐓𝐫𝐮𝐞 𝐆𝐫𝐞𝐲 “\nᵇʸ@wellahair \n\n ~𝑗𝑢𝑠𝑡 𝑙𝑜𝑣𝑒 𝑖𝑡！ @hairbyasil",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273469818_2637776609700038_1912861796343159556_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=wQys9Y7c8UcAX-CDsri&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8yBCw4BOKLYFB6HNOUwcMa-lGP8hgmHmv-Z8Ya6udutw&oe=621E6E7F",
        "permalink": "https://www.instagram.com/p/CZuvw72KH_a/",
        "thumbnail_url": "",
        "timestamp": "2022-02-08T21:52:46",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17946145789681201",
        "caption": "Striper helt hode 🌸 gjort av @marilundbyhair \n#k18 #wella #marianila",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273598000_998592290750425_7116684259250114565_n.jpg?_nc_cat=105&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=1eGO64T2L0YAX-2KA8I&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9yMff5SDqKeRPmEfvQNno_SOC6GqHvS3s5GNO26m96GQ&oe=621DF88F",
        "permalink": "https://www.instagram.com/p/CZunn_SKt-S/",
        "thumbnail_url": "",
        "timestamp": "2022-02-08T20:41:38",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17921716031313733",
        "caption": "𝐹𝑎𝑟𝑔𝑒 𝑔𝑗𝑜𝑟𝑡 𝑎𝑣 𝐻𝑜𝑎 🌻@hairbyasil",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273604388_4950038651719370_7274523327742375342_n.jpg?_nc_cat=102&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Rvfm9JmLGDoAX_etL1c&_nc_oc=AQllw9lWm4TDeiKakleHUtB6y94rmgRsVrKY4uJ_WfYp6H1cpx9Vq0DxdTcF6Io9G-M&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8t5WaNIDeZPavP13UOBoLMl5YSG8vUfHXMLp1zvy_-JA&oe=621D4EFF",
        "permalink": "https://www.instagram.com/p/CZtq-dlKrVD/",
        "thumbnail_url": "",
        "timestamp": "2022-02-08T11:51:41",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17913023612479323",
        "caption": "Soft balayage 🤩\n@stylingbypiahl \n.\n.\n.\n.\n#askforwella #wellanordic #freelightswella #olaplex #olaplexnorge #ghd #ghdhair #ghdnordic #oribeobsessed #marianila #marianilastockolm",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/273220988_1833743823487893_6880430312911376037_n.jpg?_nc_cat=107&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=m5gZZg_TXTwAX9W4hv8&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_4l0C5mO6Kak05EXj0PtUYgxJlzZqpz85ri8CFGWY01w&oe=621D3CC9",
        "permalink": "https://www.instagram.com/p/CZoe1UVKeaX/",
        "thumbnail_url": "",
        "timestamp": "2022-02-06T11:29:22",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17947608499737432",
        "caption": "Highlights by Hoa 🌼@hairbyasil",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/270019106_1296479037430070_6804808138016064651_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Hpr49-xODeIAX9KAfT2&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_ubUKivCdSrhCliCYS9Cp8-MXLzXLAn7x4eM7NZWgS0g&oe=621E0A3E",
        "permalink": "https://www.instagram.com/p/CZjktBFKhZu/",
        "thumbnail_url": "",
        "timestamp": "2022-02-04T13:44:28",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17934221137897960",
        "caption": "Striper og paneler for og skape spill i håret 😊\n@stylingbypiahl \n.\n.\n.\n.\n#askforwella #wellanordic #blondorwella #illuminacolorwella #olaplex #olaplexnorge #oribeobsessed #marianila #marianilastockholm #ghd #ghdhair #ghdnordic",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272360279_472186567653759_5847482377622440864_n.jpg?_nc_cat=103&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Jgt8aa5FMQwAX8E2Z04&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_mSj6dx2wC5pzYNbmCycd-6O_FF2awSh6JcRgdcwBIhQ&oe=621CE187",
        "permalink": "https://www.instagram.com/p/CZHUfEbKw9z/",
        "thumbnail_url": "",
        "timestamp": "2022-01-24T14:24:01",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17897976047418488",
        "caption": "𝑪𝑹𝒀𝑺𝑻𝑨𝑳 𝑪𝑳𝑬𝑨𝑹 𝑩𝑳𝑶𝑵𝑫𝑬 💎\n\nheavy balayage on beautiful @siljesilyeah💗 \n\nglossed with equal parts #colortouchwella 10/0, 10/6 and 10/81\n\n- @hairbytherese_andersen \n\n#askforwella #wellahair #balayage",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272197418_978294669447312_6409478130130722405_n.jpg?_nc_cat=104&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=k_djFbxg7vIAX8gECRK&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9AVe1seLNKcUDKCCP0NY6B8H697q5bbvHHUJ49tuKg-w&oe=621D3ECC",
        "permalink": "https://www.instagram.com/p/CZCg_DAKO_b/",
        "thumbnail_url": "",
        "timestamp": "2022-01-22T17:37:02",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17915123267265268",
        "caption": "Fra mørk kobber til lys peach 😍\n@stylingbypiahl \n.\n.\n.\n.\n#askforwella #wellanordic #blondorwella #illuminacolor #olaplex #olaplexnorge #ghdhair #ghdnordic #marianila #marianilastockholm",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272185843_319073566813273_5618020691167008729_n.jpg?_nc_cat=102&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=2L6Y2cMv91sAX-LJdQG&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_Y9DI9R2G4inFqrbIO17uqnNTjGzNwT5QVp3U5g6B_7Q&oe=621C9787",
        "permalink": "https://www.instagram.com/p/CZAAzf6qUrb/",
        "thumbnail_url": "",
        "timestamp": "2022-01-21T18:17:21",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17854759775693201",
        "caption": "Maria har stripet etterveksten og fått det litt kaldere ♥️ gjort av @marilundbyhair",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272161704_144569324608847_4101650400136665547_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=sOXzBLVwbf4AX_qnHYD&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT9ldIhZEGn1abUizY4MFXJKYKwO4ilVYhT4nwO9UDVixQ&oe=621CB64F",
        "permalink": "https://www.instagram.com/p/CY9E1FXKWnP/",
        "thumbnail_url": "",
        "timestamp": "2022-01-20T14:54:48",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17875401098629352",
        "caption": "Striper helt hode gjort av @marilundbyhair 🤍",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272100010_1145557876199587_7828265732994796443_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=AIODg8_Ed0IAX_pkgRi&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_hTBKyeSeN6I0nNUtJJqbYJ6-RZvqi2SKKfj-LGwAXiA&oe=621D7942",
        "permalink": "https://www.instagram.com/p/CY7BoVxKyS3/",
        "thumbnail_url": "",
        "timestamp": "2022-01-19T19:48:22",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17921304155128480",
        "caption": "Foilayage på dette drømmehåret 🤍 gjort av @marilundbyhair\n\n#foilayage #k18",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/272008241_985296768724068_2173060292996829975_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=fdcFlR9i0Q8AX-GSKqt&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8lw8M72e4ym-gcNfcqv3ye1YkbgagIHOd_S13kARxy_A&oe=621DA118",
        "permalink": "https://www.instagram.com/p/CY3UabPKpiD/",
        "thumbnail_url": "",
        "timestamp": "2022-01-18T09:15:32",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17855872325661677",
        "caption": "Paneler for og få en naturlig kald farge og få en fin overgang fra hennes naturlige farge 😊\n@stylingbypiahl \n.\n.\n.\n.\n#askforwella #wellanordic #illuminacolor #oribeobsessed #ghd #ghdhair #marianila #marianilastockholm",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/271666459_335620048413772_5326578835477195613_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=Fw6IrMdAaEUAX-1OdlK&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT_danqbnGbM6F_DrtAyg9B959PD0A94rM_phpeotKInyA&oe=621CBD18",
        "permalink": "https://www.instagram.com/p/CYtnDRAqTuN/",
        "thumbnail_url": "",
        "timestamp": "2022-01-14T14:45:59",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17945345668688332",
        "caption": "• babylights for å få en mykere overgang fra tidligere fargebehandling •\n\nglosset med #colortouchwella 9/97 og 9/96 med dobbel 1,9% i 10 minutter\n\nstylet med @oribe  invisible defensivt heat protectant spray, imperial blowout, @marianilastockholm volume spray 🤍🌱\n\ngjort av @hairbytherese_andersen \n\n#askforwella #babylights #foils",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/271524324_1003410210558370_1233908348898780269_n.jpg?_nc_cat=108&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=V6d3ujnm9nQAX8VeE50&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT8mVbRM8VGhRZQaD5WdhunFY9b92ZOgCPaA7jerVfI8PQ&oe=621E27D5",
        "permalink": "https://www.instagram.com/p/CYn_2VDKx6o/",
        "thumbnail_url": "",
        "timestamp": "2022-01-12T10:27:14",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    },
    {
        "id": "17908746455230544",
        "caption": "S K I N F A D E \n\n• stylet med depot no. 301 matt paste •\n\ngjort av @hairbytherese_andersen \n\n#skinfade #depot",
        "media_type": 2,
        "media_url": "https://scontent-cph2-1.cdninstagram.com/v/t51.29350-15/271610210_2761697007460478_2766366508253047667_n.jpg?_nc_cat=109&ccb=1-5&_nc_sid=8ae9d6&_nc_ohc=3YoEGZsW_AwAX_pMQd3&_nc_ht=scontent-cph2-1.cdninstagram.com&edm=ANo9K5cEAAAA&oh=00_AT-ATQdh5Nzn14Dbud4HNsg5k4sDHCBi-EaYijTlHtY0jw&oe=621E2220",
        "permalink": "https://www.instagram.com/p/CYjF1l4KHly/",
        "thumbnail_url": "",
        "timestamp": "2022-01-10T12:43:21",
        "username": "glodfrisor.ls",
        "siteId": 1562,
        "siteName": "Glød Lillestrøm"
    }
] 

export default {
    mockImages: mockImages
}
